import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Conferences from './pages/Conferences';
import UpcomingConferences from './pages/UpcomingConferences';
import PreviousConferences from './pages/PreviousConferences';
import WIEMTIGhana2018 from './pages/WIEMTIGhana2018';
import BusinessForum from './pages/BusinessForum';
import InternationalForum from './pages/InternationalForum';
import MembershipBenefits from './pages/MembershipBenefits';
import MembersShowcase from './pages/MembersShowcase';
import BecomeMember from './pages/BecomeMember';
import TradeMission from './pages/TradeMission';
import Services from './pages/Services';
import Exports from './pages/Exports';
import VIPServices from './pages/VIPServices';
import BusinessIncubator from './pages/BusinessIncubator';
import TransportationLogistics from './pages/TransportationLogistics';
import VehicleApplicationForm from './pages/VehicleApplicationForm';
import EquipmentPurchaseForm from './pages/EquipmentPurchaseForm';
import EquipmentLeaseForm from './pages/EquipmentLeaseForm';
// import MeetUs from './pages/MeetUs';  // ← REMOVED - Not being used
import WhoWeAre from './pages/WhoWeAre';
import BoardPatrons from './pages/BoardPatrons';
import BoardDirectors from './pages/BoardDirectors';
import ManagementStaff from './pages/ManagementStaff';
import InternsVolunteers from './pages/InternsVolunteers';
import Career from './pages/Career';
import ContactUs from './pages/ContactUs';
import Activities from './pages/Activities';
import DailyNews from './pages/DailyNews';
import Projects from './pages/Projects';
import Gallery from './pages/Gallery';
import CorporateActivities from './pages/CorporateActivities';
import PressReleases from './pages/PressReleases';
import FAQ from './pages/FAQ';
import Blog from './pages/Blog';
import PartnershipCollaboration from './pages/PartnershipCollaboration';
import AICISNewYork from './pages/AICISNewYork';
import Workshop from './pages/Workshop';
import UpcomingWorkshop from './pages/UpcomingWorkshop';
import PastWorkshop from './pages/PastWorkshop';
import Training from './pages/Training';
import UpcomingTraining from './pages/UpcomingTraining';
import PastTraining from './pages/PastTraining';
import './App.css';

// Scroll to top component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <main>
          <Routes>
            {/* Home */}
            <Route path="/" element={<Home />} />

            {/* About Us */}
            <Route path="/who-we-are" element={<WhoWeAre />} />
            <Route path="/board-patrons" element={<BoardPatrons />} />
            <Route path="/board-directors" element={<BoardDirectors />} />
            <Route path="/management-staff" element={<ManagementStaff />} />
            <Route path="/interns-volunteers" element={<InternsVolunteers />} />
            <Route path="/career" element={<Career />} />
            <Route path="/contact-us" element={<ContactUs />} />

            {/* Global Business Events */}
            <Route path="/conferences" element={<Conferences />} />
            <Route path="/upcoming-conferences" element={<UpcomingConferences />} />
            <Route path="/previous-conferences" element={<PreviousConferences />} />
            <Route path="/wiemti-ghana-2018" element={<WIEMTIGhana2018 />} />
            <Route path="/aicis-new-york-2026" element={<AICISNewYork />} />
            <Route path="/business-forum" element={<BusinessForum />} />
            <Route path="/international-forum" element={<InternationalForum />} />
            <Route path="/membership-benefits" element={<MembershipBenefits />} />
            <Route path="/members-showcase" element={<MembersShowcase />} />
            <Route path="/become-member" element={<BecomeMember />} />
            <Route path="/trade-mission" element={<TradeMission />} />
            <Route path="/partnership-collaboration" element={<PartnershipCollaboration />} />

            {/* Workshop & Training */}
            <Route path="/workshop" element={<Workshop />} />
            <Route path="/upcoming-workshop" element={<UpcomingWorkshop />} />
            <Route path="/past-workshop" element={<PastWorkshop />} />
            <Route path="/training" element={<Training />} />
            <Route path="/upcoming-training" element={<UpcomingTraining />} />
            <Route path="/past-training" element={<PastTraining />} />

            {/* Our Services */}
            <Route path="/services" element={<Services />} />
            <Route path="/exports" element={<Exports />} />
            <Route path="/vip-services" element={<VIPServices />} />
            <Route path="/business-incubator" element={<BusinessIncubator />} />
            <Route path="/transportation-logistics" element={<TransportationLogistics />} />

            {/* Forms */}
            <Route path="/vehicle-application" element={<VehicleApplicationForm />} />
            <Route path="/equipment-purchase" element={<EquipmentPurchaseForm />} />
            <Route path="/equipment-lease" element={<EquipmentLeaseForm />} />

            {/* Activities */}
            <Route path="/activities" element={<Activities />} />
            <Route path="/daily-news" element={<DailyNews />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/corporate-activities" element={<CorporateActivities />} />
            <Route path="/press-releases" element={<PressReleases />} />

            {/* FAQ & Blog */}
            <Route path="/faq" element={<FAQ />} />
            <Route path="/blog" element={<Blog />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;